module.exports = __webpack_public_path__ + "ico_analisis_open.png";